import React from 'react';

export const AppInventory = () => {
  return <div>App Inventory</div>;
};
